"use strict";

exports.__esModule = true;
exports.default = exports.TextAreaAnswer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TextAreaAnswer = function TextAreaAnswer(_ref) {
  var id = _ref.id,
      placeholder = _ref.placeholder,
      name = _ref.name,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      isRequired = _ref.isRequired;

  var _useState = (0, _react.useState)(!isRequired),
      isValid = _useState[0],
      setIsValid = _useState[1];

  var onTextChange = function onTextChange(e) {
    var isValid = !(isRequired && e.target.value.length === 0);
    setIsValid(isValid);
    onChange(e);
  };

  return /*#__PURE__*/_react.default.createElement(_form.TextAreaField, {
    error: isValid ? '' : _constants.VALIDATION_ERROR,
    placeholder: placeholder && placeholder.length > 0 ? placeholder : 'Please enter your answer here',
    disabled: disabled,
    onChange: function onChange(e) {
      return onTextChange(e);
    },
    id: id,
    name: name
  });
};

exports.TextAreaAnswer = TextAreaAnswer;
TextAreaAnswer.propTypes = {
  id: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  isRequired: _propTypes.default.bool
};
TextAreaAnswer.defaultProps = {
  placeholder: '',
  disabled: false,
  isRequired: false
};
var _default = TextAreaAnswer;
exports.default = _default;